import { keyframes } from '@emotion/react';
import theme from '@styles/theme';

export default {
  mainTransition(props, timingFunc = 'cubic-bezier(.4,0, .2,1)', duration = '.28s', delay = '0') {
    return {
      transitionDuration: duration,
      transitionProperty: props,
      transitionTimingFunction: timingFunc,
      transitionDelay: delay,
    };
  },
  mainAnimation(animationName = 'fadeIn', animationDuration = '.15s', rest?) {
    return {
      animationName,
      animationDuration,
      ...rest,
    };
  },
  animations: {
    fadeIn: keyframes({ from: { opacity: 0 }, to: { opacity: 1 } }),
    fadeOut: keyframes({ from: { opacity: 1 }, to: { opacity: 0 } }),
  },
  scrollbar(mt = '0', mb = '0') {
    return {
      '::-webkit-scrollbar': {
        width: '2px',
        height: '2px',
        mt,
        mb,
      },
      '::-webkit-scrollbar-track': {
        boxShadow: `inset 0 0 2px ${theme.rawColors.lightGrey500}`,
        mt,
        mb,
      },
      '::-webkit-scrollbar-thumb': {
        borderRadius: '20px',
        border: `2px solid ${theme.rawColors.darkGrey700}`,
        mt,
        mb,
      },

      scrollbarWidth: 'thin',
      scrollbarColor: `${theme.rawColors.darkGrey700} ${theme.rawColors.lightGrey300}`,
    };
  },
};
